import { ATTENTION_OFFERING_PLACEHOLDER } from './formatAttentionStatusTitle'

/**
 * The catalog title stated for the offerings that raised it.
 *
 * One offering is named outright — the reader is looking at a row about that offering. Several
 * are named by none: `Core Print, Personal Systems is not planned` reads as one offering with a
 * comma in its name, and the sentence is the payload's to conjugate, not ours. The placeholder
 * then stays for the view to replace with its own plain word.
 */
export const applyAttentionStatusOffering = (title: string, offerings: string[]): string =>
  offerings.length === 1 ? title.replace(ATTENTION_OFFERING_PLACEHOLDER, offerings[0]) : title
